var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hvh-flex align-center",attrs:{"title":_vm.limitLeafMessage}},[_vm._m(0),_c('div',{staticClass:"limit-leaf no-wrap pl-1"},[_vm._v(_vm._s(_vm.limitLeafMessage))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-treeselect__icon-container"},[_c('span',{staticClass:"vue-treeselect__icon-warning"})])
}]

export { render, staticRenderFns }